// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2nrB1","title":"Images45_title__12ZOT","images":"Images45_images__2bgwU"};